export const thinkingAreas = [
  {
    index: "01",
    area: "AI-Accelerated Development",
    description:
      "Using AI as a force multiplier — from architecture to delivery, not just autocomplete.",
    accent: "#0A84FF",
  },
  {
    index: "02",
    area: "Deep Product Thinking",
    description:
      "E2E feature ownership — from the first user need to the shipped metric.",
    accent: "#34C759",
  },
  {
    index: "03",
    area: "Systems Architecture",
    description:
      "HLD from day one. Schema-first thinking, built for what breaks next month.",
    accent: "#06b6d4",
  },
  {
    index: "04",
    area: "Experience Design",
    description:
      "DX and UX are the same discipline — clarity at every interface, code or UI.",
    accent: "#FF9500",
  },
  {
    index: "05",
    area: "AI Impact & Value",
    description:
      "Measuring AI's real footprint — outcomes and leverage, not tool adoption.",
    accent: "#7c3aed",
  },
];
